module.exports = __webpack_public_path__ + "static/media/player_bird.e017522e.png";